import { useEffect } from "react";
import warningIcon from "../../../assets/warning-icon.svg";
import { reportError } from "../../../lib/bugReporting";
import StyledButton from "../../common/buttons/StyledButton";
import BaseModal from "../../common/modals/BaseModal/BaseModal";
import ModalCloseButton from "../../common/modals/ModalCloseButton/ModalCloseButton";
import styles from "./ResultConflictModal.module.css";
import { ToolState } from "../../AccountDetails";
import { toolTypeToName } from "../../AccountDetails/utils";

const strings = {
  ok: "OK",
  messageLine1: (isPlural: boolean) =>
    ` ${isPlural ? "are" : "is"} in progress.`,
  messageLine2: (isPlural: boolean) =>
    `You must submit ${isPlural ? "these tools" : "this tool"} before completing your call.`,
  resultConflictModal: "Result In Progress Tool Conflict Modal",
};

type Props = {
  isOpen: boolean;
  inProgressTools: ToolState[];
  onRequestClose: () => void;
};

const ResultConflictModal = ({
  isOpen,
  inProgressTools,
  onRequestClose,
}: Props) => {
  useEffect(() => {
    if (isOpen && inProgressTools.length === 0) {
      reportError(
        new Error(
          "Error: Attempted to open ResultConflictModal without any in progress tools",
        ),
      );
    }
  }, [isOpen, inProgressTools.length]);

  if (isOpen && inProgressTools.length === 0) {
    return null;
  }

  const multipleTools = inProgressTools.length > 1;
  let toolNameListString = "";
  if (multipleTools) {
    const toolNames = inProgressTools.map((tool) => toolTypeToName(tool.type));
    const toolsExceptLastToolNames = toolNames.slice(0, -1);
    toolNameListString = `${toolsExceptLastToolNames.join(
      ", ",
    )} and ${toolNames.slice(-1)}`;
  } else if (inProgressTools.length === 1) {
    toolNameListString = toolTypeToName(inProgressTools[0].type);
  }

  return (
    <BaseModal
      className={styles.container}
      isOpen={isOpen}
      label={strings.resultConflictModal}
      onRequestClose={onRequestClose}
    >
      <ModalCloseButton onClick={onRequestClose} />
      <div className={styles.body}>
        <img src={warningIcon} alt="" />
        <div>
          <span className={styles.toolNameText}>{toolNameListString}</span>
          {strings.messageLine1(multipleTools)}
        </div>
        <div>{strings.messageLine2(multipleTools)}</div>
      </div>
      <div className={styles.footer}>
        <StyledButton className={styles.button} onClick={onRequestClose}>
          {strings.ok}
        </StyledButton>
      </div>
    </BaseModal>
  );
};
export default ResultConflictModal;
